import { twMerge } from 'tailwind-merge';

import type { TooltipProps } from '@/_components';
import { Tooltip } from '@/_components';
import type { ButtonProps, Ref } from '@/_components/button';
import { Button } from '@/_components/button';

type ActionButtonProps = ButtonProps & {
  placement?: TooltipProps['placement'];
};

export const ActionButton = ({
  ref,
  as = 'link',
  size = 'sm',
  className,
  placement,
  title,
  ...props
}: ActionButtonProps & {
  ref?: React.RefObject<Ref | null>;
}) => {
  return (
    <Tooltip content={title} placement={placement} zIndex={11}>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Button
        ref={ref}
        {...props}
        as={as}
        aria-label={props['aria-label'] || title}
        size={size}
        tag="div"
        iconClassName={twMerge('text-c-card-muted', props.iconClassName)}
        className={twMerge(
          'text-accent hover:text-accent opacity-40 hover:bg-black/10 dark:hover:bg-black/10 dark:hover:text-white',
          !props.disabled ? 'hover:opacity-100' : '',
          className
        )}
      />
    </Tooltip>
  );
};
